var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareQuizIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "#CFBCFF",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.543 63.1153L78.6089 34.5195L29.543 63.1153Z",
    fill: "#6D52CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.543 63.1153L78.6089 34.5195",
    stroke: "#A6A4E8",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.541 63.1182L78.8386 91.3127L29.541 63.1182Z",
    fill: "#6D52CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.541 63.1182L78.8386 91.3127",
    stroke: "#A6A4E8",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5789_16692",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 20,
    width: 32,
    height: 31
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0508 35.25C93.0508 43.6723 86.2231 50.5 77.8008 50.5C69.3785 50.5 62.5508 43.6723 62.5508 35.25C62.5508 26.8277 69.3785 20 77.8008 20C86.2231 20 93.0508 26.8277 93.0508 35.25Z",
    fill: "#FF0000"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5789_16692)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0508 35.25C93.0508 43.6723 86.2231 50.5 77.8008 50.5C69.3785 50.5 62.5508 43.6723 62.5508 35.25C62.5508 26.8277 69.3785 20 77.8008 20C86.2231 20 93.0508 26.8277 93.0508 35.25Z",
    fill: "#A6A4E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6764 26.5699C72.7725 26.3426 71.435 26.7641 71.3213 26.8181C70.6591 27.1323 70.1488 27.5977 69.8637 28.2846C69.5876 28.9495 69.5392 29.6867 69.5556 30.4065C69.6063 32.6214 71.2789 35.4136 69.6935 37.3885C68.8746 38.4084 67.4395 38.6607 66.3565 39.3939C64.2938 40.7905 63.8768 43.8978 65.0721 46.0832C66.2674 48.2685 68.7083 49.5589 71.1724 49.9246C73.6365 50.2903 76.1455 49.8524 78.5751 49.3024C80.263 48.9206 81.9893 48.4597 83.3639 47.4084C86.6039 44.9303 85.0935 41.826 83.6067 38.9236C82.6539 37.0634 84.3631 36.1874 85.1091 33.8786C86.4517 29.7242 84.5287 25.6921 80.8562 24.0997C74.8388 21.4907 72.6886 26.5412 72.6764 26.5699Z",
    fill: "#5B4852"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6781 50.4995H65.9229C65.9229 50.4995 67.0309 46.2234 68.6069 43.6901C70.1828 41.1552 75.9683 40.293 75.9683 40.293L77.8005 40.5998L79.6329 40.293C79.6329 40.293 85.42 41.1552 86.9959 43.6901C88.5719 46.2234 89.6781 50.4995 89.6781 50.4995Z",
    fill: "url(#paint0_linear_5789_16692)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5088 41.1375C75.291 45.1138 80.5526 44.6068 83.0947 41.1375C83.0947 41.1375 77.9948 38.7627 72.5088 41.1375Z",
    fill: "#F1B69A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7578 42.5578C76.7638 42.5578 75.958 41.7523 75.958 40.7583V37.3203H79.5576V40.7583C79.5576 41.7523 78.7518 42.5578 77.7578 42.5578Z",
    fill: "#F1B69A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5576 36.9219V39.0328C79.5576 39.0328 78.9531 40.0835 77.7575 40.0835C76.7971 40.0835 75.958 39.1725 75.958 39.1725V36.9219H79.5576Z",
    fill: "#150A08"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7212 33.227C71.7483 31.7487 70.6191 32.6982 70.6191 33.7391C70.6191 35.2461 72.2539 36.5445 73.1882 35.4627C74.1224 34.3809 72.7212 33.227 72.7212 33.227Z",
    fill: "#F1B69A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5099 33.9097C71.9042 32.7775 71.0672 33.8341 71.3869 34.2534",
    stroke: "#E07E61",
    strokeWidth: 0.636307,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4434 33.227C83.4166 31.7487 84.5455 32.6982 84.5455 33.7391C84.5455 35.2461 82.9106 36.5445 81.9764 35.4627C81.0422 34.3809 82.4434 33.227 82.4434 33.227Z",
    fill: "#F1B69A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6572 33.9097C83.263 32.7775 84.0999 33.8341 83.7802 34.2534",
    stroke: "#E07E61",
    strokeWidth: 0.636307,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5787 39.0324C73.7329 39.0309 71.4589 34.8286 72.358 30.5137C73.0985 26.9584 82.0677 26.9596 82.8082 30.5137C83.7074 34.8286 81.4263 39.0339 77.5787 39.0324Z",
    fill: "#F1B69A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0684 34.7116C77.4642 34.9004 78.3558 34.4817 78.3744 34.7116C78.393 34.9416 77.9013 35.145 77.7214 35.145C77.5414 35.145 77.0684 34.7116 77.0684 34.7116Z",
    fill: "#F1B69A"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0806 33.5547C76.5194 34.7677 77.3582 35.0034 77.583 35.0327",
    stroke: "#E07E61",
    strokeWidth: 0.636307,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0619 30.2477C75.8216 29.7112 74.4134 29.9562 74.2142 30.3383C74.015 30.7205 74.6738 30.8279 75.1631 30.8038C75.6523 30.7797 76.215 30.5893 76.0619 30.2477Z",
    fill: "#5B4852"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1037 30.2477C79.3441 29.7112 80.7523 29.9562 80.9514 30.3383C81.1506 30.7205 80.4918 30.8279 80.0026 30.8038C79.5134 30.7797 78.9506 30.5893 79.1037 30.2477Z",
    fill: "#150A08"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0439 32.3164C75.0439 32.5299 75.2172 32.7032 75.4307 32.7032C75.6445 32.7032 75.8174 32.5299 75.8174 32.3164C75.8174 32.1026 75.6445 31.9297 75.4307 31.9297C75.2172 31.9297 75.0439 32.1026 75.0439 32.3164Z",
    fill: "#150A08"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1211 32.3164C80.1211 32.5299 79.9482 32.7032 79.7344 32.7032C79.5206 32.7032 79.3477 32.5299 79.3477 32.3164C79.3477 32.1026 79.5206 31.9297 79.7344 31.9297C79.9482 31.9297 80.1211 32.1026 80.1211 32.3164Z",
    fill: "#150A08"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1436 35.6719C77.6155 35.8302 78.5994 35.6682 79.2979 35.692C79.2979 35.692 78.4164 36.9373 77.3797 36.6897C76.343 36.442 76.1436 35.6719 76.1436 35.6719Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1612 37.0493C77.6995 37.0509 78.4715 36.7706 78.591 37.0493C78.7106 37.3281 78.0533 37.885 77.6455 37.8454C77.2378 37.8057 76.5463 37.0478 77.1612 37.0493Z",
    fill: "#F1B69A"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M75.044 26.7234C75.0369 30.3462 81.9187 32.0865 83.2527 31.2301C84.5871 30.3736 83.5467 27.2998 80.0322 26.4672C76.5177 25.6345 75.0461 25.6446 75.044 26.7234Z",
    fill: "#5B4852"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0588 26.6943C75.9357 28.4447 73.5259 32.3085 72.1567 32.0526C70.7876 31.7967 70.7879 30.2833 71.8557 28.489C72.9235 26.6946 74.6428 25.8638 75.0588 26.6943Z",
    fill: "#5B4852"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5789_16692",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 75,
    width: 32,
    height: 32
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4329 91.3722C93.4329 100.002 86.4368 106.998 77.8068 106.998C69.1768 106.998 62.1807 100.002 62.1807 91.3722C62.1807 82.7422 69.1768 75.7461 77.8068 75.7461C86.4368 75.7461 93.4329 82.7422 93.4329 91.3722Z",
    fill: "#FF0000"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5789_16692)"
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4329 91.3722C93.4329 100.002 86.4368 106.998 77.8068 106.998C69.1768 106.998 62.1807 100.002 62.1807 91.3722C62.1807 82.7422 69.1768 75.7461 77.8068 75.7461C86.4368 75.7461 93.4329 82.7422 93.4329 91.3722Z",
    fill: "#A6A4E8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7101 88.52C85.8606 84.6479 84.1576 82.4281 82.781 83.1544C82.781 83.1544 82.5725 80.7532 79.4207 79.3056C75.7739 77.6305 71.0636 78.9366 70.1454 81.4595C69.2981 83.7878 70.8114 84.9098 70.8114 84.9098C70.8114 84.9098 69.8744 86.583 71.477 89.0863C73.0797 91.5896 82.7472 90.2539 83.7101 88.52Z",
    fill: "#5B4852"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4181 107.322H64.1943C64.1943 107.322 65.02 102.756 66.8911 100.128C68.7622 97.4982 75.7064 96.5391 75.7064 96.5391L77.8062 96.8631L79.9061 96.5391C79.9061 96.5391 86.8525 97.4982 88.7236 100.128C90.5946 102.756 91.4181 107.322 91.4181 107.322Z",
    fill: "url(#paint1_linear_5789_16692)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7062 96.5391L73.0176 97.0435C73.0176 97.0435 73.6373 100.085 76.0956 101.605L77.7648 99.5596V97.3654L75.7062 96.5391Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7207 96.5391L82.4093 97.0435C82.4093 97.0435 81.7896 100.085 79.3313 101.605L77.6621 99.5596V97.3654L79.7207 96.5391Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7612 98.8588C76.7427 98.8588 75.917 98.0334 75.917 97.0149V93.4922H79.6054V97.0149C79.6054 98.0334 78.7797 98.8588 77.7612 98.8588Z",
    fill: "#F1B69A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6054 93.0859V95.2489C79.6054 95.2489 78.986 96.3255 77.7609 96.3255C76.7767 96.3255 75.917 95.392 75.917 95.392V93.0859H79.6054Z",
    fill: "#150A08"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6012 89.2966C71.6042 87.7818 70.4473 88.7547 70.4473 89.8213C70.4473 91.3655 72.1224 92.6959 73.0796 91.5874C74.0369 90.4789 72.6012 89.2966 72.6012 89.2966Z",
    fill: "#F1B69A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3831 89.9964C71.7624 88.8364 70.9048 89.9189 71.2324 90.3486",
    stroke: "#E07E61",
    strokeWidth: 0.652,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5624 89.2966C83.5597 87.7818 84.7163 88.7547 84.7163 89.8213C84.7163 91.3655 83.0412 92.6959 82.084 91.5874C81.1267 90.4789 82.5624 89.2966 82.5624 89.2966Z",
    fill: "#F1B69A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7812 89.9964C83.4019 88.8364 84.2595 89.9189 83.932 90.3486",
    stroke: "#E07E61",
    strokeWidth: 0.652,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5765 95.2457C73.6359 95.2442 71.3058 90.9382 72.2271 86.517C72.9859 82.8739 82.1762 82.8752 82.935 86.517C83.8564 90.9382 81.519 95.2473 77.5765 95.2457Z",
    fill: "#F1B69A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0527 90.8228C77.4584 91.0162 78.3719 90.5871 78.391 90.8228C78.41 91.0584 77.9062 91.2669 77.7218 91.2669C77.5375 91.2669 77.0527 90.8228 77.0527 90.8228Z",
    fill: "#F1B69A"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0648 89.6328C76.4898 90.8757 77.3492 91.1173 77.5795 91.1473",
    stroke: "#E07E61",
    strokeWidth: 0.652,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2051 91.8253C77.7264 92.1175 78.9328 91.8741 79.4197 91.4844",
    stroke: "#150A08",
    strokeWidth: 0.652,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0234 86.2437C75.7771 85.6939 74.3342 85.9449 74.1302 86.3365C73.9261 86.7281 74.6011 86.8381 75.1024 86.8134C75.6037 86.7887 76.1803 86.5937 76.0234 86.2437Z",
    fill: "#150A08"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1405 86.2437C79.3868 85.6939 80.8297 85.9449 81.0338 86.3365C81.2378 86.7281 80.5628 86.8381 80.0615 86.8134C79.5602 86.7887 78.9836 86.5937 79.1405 86.2437Z",
    fill: "#150A08"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2268 92.5719C77.7784 92.5735 78.5694 92.2863 78.6919 92.5719C78.8144 92.8576 78.1409 93.4282 77.7231 93.3876C77.3052 93.3467 76.5968 92.5704 77.2268 92.5719Z",
    fill: "#F1B69A"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9805 88.365C74.9805 88.5841 75.158 88.7613 75.3767 88.7613C75.5958 88.7613 75.773 88.5841 75.773 88.365C75.773 88.146 75.5958 87.9688 75.3767 87.9688C75.158 87.9688 74.9805 88.146 74.9805 88.365Z",
    fill: "#150A08"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1832 88.365C80.1832 88.5841 80.006 88.7613 79.7869 88.7613C79.5678 88.7613 79.3906 88.5841 79.3906 88.365C79.3906 88.146 79.5678 87.9688 79.7869 87.9688C80.006 87.9688 80.1832 88.146 80.1832 88.365Z",
    fill: "#150A08"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0712 83.7858C80.0496 86.0766 77.8138 84.7724 77.8138 84.7724C77.8138 84.7724 76.3475 86.1459 74.0936 85.9269C71.8396 85.7078 70.6652 83.0051 73.4091 81.8619C76.1531 80.7187 82.5076 80.5646 81.0712 83.7858Z",
    fill: "#5B4852"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5789_16692",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 46,
    width: 32,
    height: 32
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6206 46.4805C38.2417 46.4805 45.2413 53.4801 45.2413 62.1011C45.2413 70.7221 38.2417 77.7217 29.6206 77.7217C20.9996 77.7217 14 70.7221 14 62.1011C14 53.4801 20.9996 46.4805 29.6206 46.4805Z",
    fill: "#FF0000"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5789_16692)"
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M29.689 46.3906C38.31 46.3906 45.3096 53.3902 45.3096 62.0113C45.3096 70.6323 38.31 77.6319 29.689 77.6319C21.068 77.6319 14.0684 70.6323 14.0684 62.0113C14.0684 53.3902 21.068 46.3906 29.689 46.3906Z",
    fill: "#A6A4E8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1191 51.8257C31.5274 48.8062 34.8612 46.972 36.8616 49.1345C38.8619 51.2971 37.3702 52.9201 35.3485 53.12C33.3269 53.3199 32.6306 51.7491 32.6306 51.7491L32.1191 51.8257Z",
    fill: "#5B4852"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6709 51.7097C31.2282 49.9929 34.183 51.3894 34.8938 52.5416C35.6048 53.6938 35.2755 55.3686 35.2755 55.3686L30.6709 51.7097Z",
    fill: "#7B2B1A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9988 59.2477C22.105 53.1388 26.3798 50.92 30.0975 51.0022C33.8152 51.0844 35.5728 54.0426 35.5728 54.0426C35.5728 54.0426 38.2327 57.9899 34.9761 61.6114C31.7195 65.2329 22.9988 59.2477 22.9988 59.2477Z",
    fill: "#5B4852"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M41.855 77.6304H17.5225C17.5225 77.6304 18.6575 73.2503 20.2717 70.6554C21.8859 68.059 27.8121 67.1758 27.8121 67.1758L29.6887 67.4901L31.5657 67.1758C31.5657 67.1758 37.4934 68.059 39.1077 70.6554C40.7219 73.2503 41.855 77.6304 41.855 77.6304Z",
    fill: "url(#paint2_linear_5789_16692)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1719 68.4998C25.4594 73.2119 32.4068 73.6537 36.207 68.4998C36.207 68.4998 30.6663 64.9583 23.1719 68.4998Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6443 69.4937C28.6262 69.4937 27.8008 68.6686 27.8008 67.6504V64.1289H31.4879V67.6504C31.4879 68.6686 30.6625 69.4937 29.6443 69.4937Z",
    fill: "#F1B69A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4879 63.7227V65.8849C31.4879 65.8849 30.8687 66.9611 29.644 66.9611C28.6602 66.9611 27.8008 66.0279 27.8008 66.0279V63.7227H31.4879Z",
    fill: "#150A08"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4852 59.937C23.4886 58.4227 22.332 59.3952 22.332 60.4615C22.332 62.0051 24.0066 63.3351 24.9635 62.227C25.9204 61.1188 24.4852 59.937 24.4852 59.937Z",
    fill: "#F1B69A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2684 60.6369C23.6479 59.4772 22.7907 60.5594 23.1181 60.989",
    stroke: "#E07E61",
    strokeWidth: 0.651772,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M34.443 59.937C35.4399 58.4227 36.5962 59.3952 36.5962 60.4615C36.5962 62.0051 34.9216 63.3351 33.9647 62.227C33.0078 61.1188 34.443 59.937 34.443 59.937Z",
    fill: "#F1B69A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6611 60.6369C35.2816 59.4772 36.1388 60.5594 35.8114 60.989",
    stroke: "#E07E61",
    strokeWidth: 0.651772,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4613 65.8863C25.5221 65.8847 23.1928 61.5803 24.1137 57.1606C24.8723 53.5188 34.0594 53.52 34.8179 57.1606C35.7389 61.5803 33.4024 65.8878 29.4613 65.8863Z",
    fill: "#F1B69A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9375 61.4595C29.343 61.6528 30.2562 61.2239 30.2753 61.4595C30.2943 61.695 29.7907 61.9034 29.6064 61.9034C29.4221 61.9034 28.9375 61.4595 28.9375 61.4595Z",
    fill: "#F1B69A"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9505 60.2734C28.3757 61.5159 29.2348 61.7574 29.465 61.7874",
    stroke: "#E07E61",
    strokeWidth: 0.651772,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9065 56.8881C27.6603 56.3386 26.2179 56.5894 26.0139 56.9809C25.8099 57.3723 26.485 57.4823 26.9858 57.4576C27.4869 57.4329 28.0633 57.238 27.9065 56.8881Z",
    fill: "#5B4852"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0223 56.8881C31.2685 56.3386 32.7109 56.5894 32.9149 56.9809C33.1189 57.3723 32.4441 57.4823 31.943 57.4576C31.4419 57.4329 30.8655 57.238 31.0223 56.8881Z",
    fill: "#5B4852"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8643 59.0057C26.8643 59.2247 27.0418 59.4019 27.2605 59.4019C27.4796 59.4019 27.6568 59.2247 27.6568 59.0057C27.6568 58.7866 27.4796 58.6094 27.2605 58.6094C27.0418 58.6094 26.8643 58.7866 26.8643 59.0057Z",
    fill: "#150A08"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M32.065 59.0057C32.065 59.2247 31.8878 59.4019 31.6687 59.4019C31.4497 59.4019 31.2725 59.2247 31.2725 59.0057C31.2725 58.7866 31.4497 58.6094 31.6687 58.6094C31.8878 58.6094 32.065 58.7866 32.065 59.0057Z",
    fill: "#150A08"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0811 62.5635C29.6019 62.8556 30.8078 62.6122 31.2945 62.2227",
    stroke: "#150A08",
    strokeWidth: 0.651772,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1007 63.3141C29.6521 63.3156 30.4429 63.0285 30.5653 63.3141C30.6875 63.5996 30.0145 64.1704 29.5968 64.1295C29.1791 64.0888 28.4709 63.3125 29.1007 63.3141Z",
    fill: "#F1B69A"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2754 53.3669C23.7303 55.5216 24.7728 61.6833 25.9772 65.3404C25.9772 65.3404 21.7752 59.3015 23.6566 55.5216C25.5379 51.7418 30.2754 53.3669 30.2754 53.3669Z",
    fill: "#5B4852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5789_16692",
    x1: 65.6233,
    y1: 45.2132,
    x2: 89.3786,
    y2: 45.2132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A74DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#634EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D278D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5789_16692",
    x1: 64.0787,
    y1: 101.711,
    x2: 91.3025,
    y2: 101.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A74DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#634EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D278D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5789_16692",
    x1: 17.5159,
    y1: 72.3312,
    x2: 41.8485,
    y2: 72.3312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A74DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#634EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D278D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareQuizIcon);
export default __webpack_public_path__ + "static/media/share_quiz_icon.0bdba6a389fe8fe994ad8b079e7d601b.svg";
export { ForwardRef as ReactComponent };